import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

export const Overlay = styled.div`
    animation: ${fadeIn} 0.2s ease-out;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`
